import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-letter-u', 'IconCircleLetterU', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M10 8v6a2 2 0 1 0 4 0v-6', key: 'svg-1' }],
]);
